import type { FormikProps } from 'formik'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import type { SettingsResponse } from '../../interfaces'
import { MediaLibrarySettingsLayout } from '../../layouts/Settings'

const MediaLibrarySettingsPage = (props: {
  form?: FormikProps<SettingsResponse>
}): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Media Library Settings</title>
      <meta name="description" content="Media Library Settings page" />
    </Helmet>
    <MediaLibrarySettingsLayout form={props.form} />
  </React.Fragment>
)

export default MediaLibrarySettingsPage
